<template>
    <div class="qzsy-table-container">
        <table class="qzsy-table">
            <thead>
                <tr>
                    <th class="col-dizhi">地支</th>
                    <th class="col-gongwei">宫位</th>
                    <th class="col-shensha">神煞</th>
                </tr>
            </thead>
            <tbody>
                <tr v-for="(item, index) in data" :key="index">
                    <td class="col-dizhi">{{ item[0] || '' }}</td>
                    <td class="col-gongwei">{{ item[1] || '' }}</td>
                    <td class="col-shensha multi-line">{{ item[2] || '' }}</td>
                </tr>
            </tbody>
        </table>
    </div>
</template>

<script setup>
import { defineProps } from 'vue';

defineProps({
    data: {
        type: Array,
        default: () => []
    }
})
</script>

<style scoped>
.qzsy-table-container {
    color: white;
}

.qzsy-table {
    width: 100%;
    border-collapse: collapse;
    color: white;
}

.qzsy-table th,
.qzsy-table td {
    padding: 10px 8px;
    border: 1px solid #444;
}

/* 列宽设置 */
.col-dizhi {
    width: 100px;
    text-align: center;
}

.col-gongwei {
    width: 120px;
    text-align: center;
}

.col-shensha {
    text-align: left;
    /* 神煞列左对齐 */
}

.multi-line {
    white-space: pre-line;
    padding-left: 12px;
    color: white;
}

/* 表头样式 */
.qzsy-table th {
    background-color: #33334d;
    font-weight: bold;
    color: #b0a0ff;
}

/* 表格行样式 */
.qzsy-table tr:nth-child(even) {
    background-color: rgba(40, 40, 60, 0.5);
}

.qzsy-table tr:nth-child(odd) {
    background-color: rgba(30, 30, 45, 0.5);
}

.qzsy-table tr:hover {
    background-color: rgba(110, 90, 210, 0.2);
}
</style>